'use client'

import { Toaster as SonnerToaster } from 'sonner'

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      duration={4500}
      gap={10}
      offset={24}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-start gap-3 rounded-sm border border-gray-200 border-l-2 bg-white px-4 py-3 shadow-sm font-sans',
          title:
            'text-sm font-semibold leading-snug text-charcoal-900 tracking-tight',
          description:
            'mt-0.5 text-xs leading-snug text-charcoal-700',
          icon: 'shrink-0',
          success: 'border-l-brand-green',
          error: 'border-l-brand-red',
          info: 'border-l-charcoal-900',
          warning: 'border-l-brand-yellow',
          closeButton:
            'text-charcoal-500 hover:text-charcoal-900 transition-colors',
        },
      }}
    />
  )
}
